
















































































































































































































import { Vue, Component } from 'vue-property-decorator';

import { appName } from '@/env';
import {
  readDashboardMiniDrawer,
  readHasAdminAccess,
  readIsLoggedIn,
  readUserProfile,
} from '@/store/main/getters';
import { commitSetDashboardMiniDrawer } from '@/store/main/mutations';
import {
  dispatchCheckLoggedIn,
  dispatchUserLogOut,
} from '@/store/main/actions';
import store from '@/store';

const startRouteGuard = async (to, from, next) => {
  await dispatchCheckLoggedIn(store);
  if (readIsLoggedIn(store)) {
    if (
      ['/login', '/login/', '/', '/register/', '/register'].includes(to.path)
    ) {
      next('/domains/');
    } else {
      next();
    }
  } else if (readIsLoggedIn(store) === false) {
    if (
      to.path === '/' ||
      (to.path as string).startsWith('/main') ||
      (to.path as string).startsWith('/domains')
    ) {
      next('/login');
    } else {
      next();
    }
  }
};

@Component
export default class Main extends Vue {
  public appName = appName;
  public drawer = false;

  public beforeRouteEnter(to, from, next) {
    startRouteGuard(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    startRouteGuard(to, from, next);
  }

  get miniDrawer() {
    return readDashboardMiniDrawer(this.$store);
  }

  public switchMiniDrawer() {
    commitSetDashboardMiniDrawer(
      this.$store,
      !readDashboardMiniDrawer(this.$store),
    );
  }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }

  get isLoggedIn() {
    return readIsLoggedIn(this.$store);
  }

  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      if (userProfile.full_name) {
        return userProfile.full_name;
      } else {
        return userProfile.email;
      }
    }
    return '';
  }
}
